import {
  CLEAR_DEPARTURE_TIME_FILTER,
  TOGGLE_DEPARTURE_TIME_FILTER,
} from '../helpers/constants/actionsConstants';

import type { DepartureTimeFilterAction } from '../actions/types';
import type { DepartureTimeFilterState } from '../selectors/types';

const initialState: DepartureTimeFilterState = {
  EARLY_MORNING: false,
  MORNING: false,
  AFTERNOON: false,
  EVENING: false,
};

const reducer = (
  state: DepartureTimeFilterState = initialState,
  action: DepartureTimeFilterAction,
): DepartureTimeFilterState => {
  switch (action.type) {
    case TOGGLE_DEPARTURE_TIME_FILTER:
      return { ...state, [action.payload]: !state[action.payload] };

    case CLEAR_DEPARTURE_TIME_FILTER:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
